import React from 'react';
import Card from 'components/Card';
import s from './NothingToDisplay.module.scss';

type Props = {
  text?: string;
  isBordered?: boolean;
};

const displayAsText = ({ text, children }: Parameters<React.FC<Props>>[0]): boolean => Boolean(
  text
  || !children
  || typeof children === 'string',
);

const NothingToDisplay: React.FC<Props> = ({ text, children, isBordered=true }) => (
  <Card
    isBordered={isBordered}
    className={s.card}
    style={{ borderStyle: isBordered && 'dashed' || undefined }}
  >
    { displayAsText({ children, text })
      ? <p className='caption'>{text || children || 'Nothing to display'}</p>
      : <div className={s.element_wrapper}>{children}</div>
    }
  </Card>
);

export default NothingToDisplay;
